import { c as _c } from "react/compiler-runtime";
export default function RequiredIndicator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><span className="text-destructive -ml-1" aria-hidden="true">*</span><span className="sr-only">(required)</span></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}